import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';

import { SpecialProjectBannerSkeleton } from '../../components/SpecialProjectBannerSkeleton';
import { AdfoxContextProviderProps } from '../../utils/AdfoxContext';
import { AdFoxBannerContainer } from '../AdFoxBannerContainer';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  isSp: true,
  place: 'above_offers',
};

const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 174 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'cwlpf', p2: 'hyhj' };

export function SpecialProjectBannerContainer() {
  const { state: isVisibleBanner, setFalse: setBannerInvisible } = useBooleanState(true);

  if (!isVisibleBanner) {
    return null;
  }

  return (
    <SpecialProjectBannerSkeleton>
      <AdFoxBannerContainer
        onStub={setBannerInvisible}
        onError={setBannerInvisible}
        bannerName="Баннер AdFox для спецпроектов"
        size={SIZE}
        pParams={P_PARAMS}
        postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      />
    </SpecialProjectBannerSkeleton>
  );
}
